import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as classNames from 'classnames';
import * as update from "immutability-helper";
import { Route, Link, withRouter } from 'react-router-dom';
import * as Config from '../../../configuration/consts';

@withRouter
export class Item extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = { showDetail: false, showMenu: false };
        this.onToggleClicked = this.onToggleClicked.bind(this);
        this.onEditResource = this.onEditResource.bind(this);
        this.onFlagFavourite = this.onFlagFavourite.bind(this);
        this.onMenuClicked = this.onMenuClicked.bind(this);
        this.onMoveToTop = this.onMoveToTop.bind(this);
        this.onMoveToBottom = this.onMoveToBottom.bind(this);
        this.onMoveToMiddle = this.onMoveToMiddle.bind(this);
    }

    onMenuClicked(event) {
        this.setState({ showMenu: !this.state.showMenu });
        event.stopPropagation();
    }
    onEditResource(){
        this.setState({ showMenu: false });
        this.props.editResource(this.props.id, false);
        window.scrollTo(0, 0);
        event.stopPropagation();
    }

    componentDidMount() {
        let hash = this.props.location.hash;
        if (hash) {
            const domElement = ReactDOM.findDOMNode(this.refs[hash.replace('#', '')]);
            if (domElement) {
                domElement.scrollIntoView();
                this.onToggleClicked();
            }
        }
    }

    onFlagFavourite(){
        if(this.props.userRole == Config.ROLE_ADMIN){
            this.props.flagResource(this.props.forum.id, this.props.id);
        }
    }

    onToggleClicked() {
        this.setState({ showDetail: !this.state.showDetail, showMenu: false });
    }

    onAddTagClicked(resourceId, tagId) {
        this.setState({ showMenu: false });
        this.props.addResourceTag(resourceId, tagId);
        event.stopPropagation();
    }

    
    onMoveToTop(){

        let newIndex = 0;
        this.props.moveItem(this.props.id, newIndex);
        this.setState({ showMenu: false });
    }

    onMoveToBottom(){
        
        let newIndex = this.props.totalResources ? this.props.totalResources : 0;
        this.props.moveItem(this.props.id, newIndex);
        this.setState({ showMenu: false });
    }
    
    onMoveToMiddle(){
        let newIndex = this.props.totalResources ? parseInt(`${this.props.totalResources / 2}`) : 0;
        this.props.moveItem(this.props.id, newIndex);
        this.setState({ showMenu: false });
    }

    render() {
        const { active, forum, userRole, currentUser, activeFilter, link, title, summary, author, year, type, file, tags, favourite, id } = this.props;
        let isAdmin = userRole == Config.ROLE_ADMIN;
        let summaryDetail = this.state.showDetail ? <div className="col-12 mt-3 mb-3">{summary}</div> : undefined;

        let editMode = isAdmin && activeFilter && activeFilter.id ? 
                        <span>
                            <a className="mx-1" onClick={this.onEditResource}>
                                <span className="fa fa-edit fa-lg"></span>
                            </a>
                        </span> : undefined;

        
        let expandButtonCss = !this.state.showDetail ? "fa-plus" : "fa-minus";

        let directLink = file && file.id ? `/api/attachment/${file.id}` : link ? link : undefined;

        let quickDownloadLink =  directLink ? <a href={directLink} target="_blank" className="mx-1 ">
                                            <span className="fa fa-chevron-right fa-lg"></span>
        </a> : undefined;

        let linkName = file && file.id ? file.fileName : link ? link : "";
        linkName = linkName.length > 30 ? `${linkName.substr(0,30)}...` : linkName;

        let icon = file && file.id ? "paperclip" : link ? "globe" : undefined;
        let downloadLink =  directLink ? <a href={directLink} target="_blank" className="px-2 my-2">
                                            <i className={`text-muted fa fa-${icon}`} aria-hidden="true"></i> <u>{linkName}</u>
                                        </a> : undefined;
        let fileType = undefined;
        if(file && file.fileType){
            let splitFileType = file.fileType.split("/");
            if (splitFileType.length == 2 && splitFileType[0] == "image"){
                fileType = Config.ATTACH_IMAGE;
            } else {
                fileType = Config.ATTACH_FILE;
            }
        }

        let tagsBadges = tags.map((item, index) => {
            return <span key={index} className="badge badge-pill badge-default">{item.name}</span>
        });


        let tagMenu = forum && forum.tags ? forum.tags.map((item, index) => {
            let added = tags && tags.find(t => t.id == item.id) ? <span className="fa fa-check" style={{ width: "25px"}}></span> : undefined; 
            return item.type == "RESOURCE" ? <a key={index} className="dropdown-item" href="#" 
                                                onClick={this.onAddTagClicked.bind(this, id, item.id)}>{added}{item.name}</a> : undefined
        }) : undefined;

        let showSubMenu = this.state.showMenu ? "show" : "";
        let menu = isAdmin ? <span className={`dropdown ${showSubMenu}`}>
                        <button className="btn btn-default" style={{ marginTop: "-3px" }} onClick={this.onMenuClicked}>
                            <span className="fa fa-ellipsis-v"></span>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                                
                                <a className="dropdown-item" onClick={this.onEditResource}>
                                    <span className="fa fa-edit" style={{ width: "25px"}}></span> EDIT
                                </a>
                                
                                <span><strong className="pl-2">Move to:</strong></span>
                                <a className="dropdown-item" onClick={this.onMoveToTop}>
                                    <span className="fa fa-angle-double-up" style={{ width: "25px"}}></span> TOP
                                </a>
                                <a className="dropdown-item" onClick={this.onMoveToMiddle}>
                                    <span className="fa fa-arrows-h" style={{ width: "25px"}}></span> MIDDLE
                                </a>
                                <a className="dropdown-item" onClick={this.onMoveToBottom}>
                                    <span className="fa fa-angle-double-down" style={{ width: "25px"}}></span> BOTTOM
                                </a>
                                <span><strong className="pl-2">Add tag to resource:</strong>
                                {tagMenu }</span> 
                        </div>
                </span> : undefined;
        let resourceType = file && file.id ? fileType.toUpperCase() : link ? Config.ATTACH_LINK : Config.ATTACH_UNKNOWN;
        
        return (
            <div className={classNames("row pt-3 pb-3 clickable", {"fade": active})}>
                    {this.props.children ? <div className="col-12">{this.props.children}</div> : undefined}
                    <div className="col-12 col-md-6 pb-2"  onClick={this.onToggleClicked}>
                        <div><strong>{title}</strong></div>
                    </div>
                    <div className="col-5 col-md-3 pb-2"  onClick={this.onToggleClicked}>
                        {author}
                    </div>
                    <div className="col-2 col-md-1 pb-2"  onClick={this.onToggleClicked}>
                        {year}
                    </div>
                    <div className="col-3 col-md-2 px-0 mx-0 pb-2">
                        <div className="text-right ">
                            {menu}
                        </div>
                    </div>
                {summaryDetail}
                <div className="col col-12 col-md-6">
                    {downloadLink}
                </div>
                <div className="col col-12 col-md-6 mx-0 px-0 text-right ">
                    {tagsBadges}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Resources/Item.tsx